import { render, staticRenderFns } from "./WindowLayout.vue?vue&type=template&id=7696a4f5&"
import script from "./WindowLayout.vue?vue&type=script&lang=js&"
export * from "./WindowLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports